angular.module('tf.directives')
    .directive('fileBrowser', ['$compile','$timeout',
        function ($compile, $timeout) {
        return{
            restrict:'E',
            replace:true,
            scope:{
                data : '=',
                value: '=',
                history: '='
                //selectedKey:'='
            },
            templateUrl:'js/components/fileBrowser/fileBrowser.html',
            link: function(scope, element){
                var history = [JSON.parse(scope.data)];
                scope.visibility = false;
                scope.selectedKey= null;
                scope.canGoBack = false;

                scope.getTree = function(){
                    return history[history.length-1];
                };

                scope.getType = function(value){
                    if(typeof(value)==='string'){
                        return 'file';
                    }
                    else{
                        return 'folder';
                    }
                };

                scope.click = function(key, value){
                    if(scope.getType(value)==='folder'){
                        browse(key,value);
                    }else{
                        select(key,value);
                    }
                };

                function browse(key,value){
                    history.push(scope.getTree()[key]);
                    scope.canGoBack=true;
                }

                function select(key,value){
                    scope.value = value;
                    scope.selectedKey = key;
                    scope.visibility = false;
                }

                function find(data, value){
                    //Check files first
                    for (var key in data) {
                        if(scope.getType(data[key])!=='folder'){
                            if(data[key]===value){
                                scope.selectedKey = key;
                                return true;
                            }
                        }
                    }

                    //Check folders last
                    for (key in data) {
                        if(scope.getType(data[key])==='folder'){
                            browse(key, data[key]);
                            if(!find(data[key], value)){
                                scope.back();
                            }else{
                                return true;
                            }
                        }
                    }

                    return false;
                }

                scope.back = function(){
                    if(history.length>1){
                        history.pop();

                        if(history.length<2){
                            scope.canGoBack=false;    
                        }
                    }
                };

                scope.toggle = function(){
                    scope.visibility = !scope.visibility;
                };

                if(scope.value){
                    find(history[history.length-1], scope.value);
                }
            }
        };
    }]);